import React from 'react';
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import CategoryList from '../Categories/CategoryList';

interface SidebarProps {
  open?: boolean;
  onClose?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ open = true, onClose }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  // For desktop, show as a permanent sidebar; for mobile, show as a Drawer (hidden)
  if (isDesktop) {
    return (
      <Box
        sx={{
          width: 260,
          flexShrink: 0,
          bgcolor: 'background.paper',
          borderRight: '1px solid #eee',
          height: '100vh',
          position: 'sticky',
          top: 0,
          display: { xs: 'none', md: 'block' },
          overflowY: 'auto',
        }}
      >
        <CategoryList />
      </Box>
    );
  }
  // For mobile, use Drawer (hidden by default)
  return (
    <Drawer anchor="left" open={!!open} onClose={onClose}>
      <Box sx={{ width: 260, p: 2 }}>
        <CategoryList onCategorySelect={onClose} />
      </Box>
    </Drawer>
  );
};

export default Sidebar;
